import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

/**
 * @param {moment} from
 * @param {moment} to
 */
export const setInterval = (from, to, shortcut) => ({
  type: types.SET_INTERVAL,
  from,
  to,
  shortcut,
});

export const setMetric = metric => ({
  type: types.SET_METRIC,
  metric,
});

export const setCode = code => ({
  type: types.SET_CODE,
  code,
});

export const setCurrentErrorCode = currentErrorCode => ({
  type: types.SET_CURRENT_ERROR_CODE,
  currentErrorCode,
});

export const setErrorCodeSelected = errorCodeSelected => ({
  type: types.SET_ERROR_CODE_SELECTED,
  errorCodeSelected,
});

export const setFilter = filter => ({
  type: types.SET_FILTER,
  filter,
});

export const addErrorCode = code => ({
  type: types.ADD_ERROR_CODE,
  code,
});

export const removeErrorCode = index => ({
  type: types.REMOVE_ERROR_CODE,
  index,
});

export const setBaseState = state => ({
  type: types.SET_BASE_STATE,
  state,
});
